import { render, staticRenderFns } from "./AccountEmployeesPortal.vue?vue&type=template&id=12f62c4f&scoped=true"
import script from "./AccountEmployeesPortal.vue?vue&type=script&lang=js"
export * from "./AccountEmployeesPortal.vue?vue&type=script&lang=js"
import style0 from "./AccountEmployeesPortal.vue?vue&type=style&index=0&id=12f62c4f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f62c4f",
  null
  
)

export default component.exports